import { Context } from '@nuxt/types';

export default function(context: Context) {
  const { redirect } = context;
  redirect('/');
}
